<template>
  <div v-if="(dimensions ?? []).length">
    <div v-for="d in dimensions" class="flex flex_gap_5 align-items-center mb-1" v-if="d.id">
      <img src="/assets/icons/dimensions.png">
      <span>{{ d.array_value.depth }}/{{ d.array_value.width }}/{{ d.array_value.height }}</span>
      <img src="/assets/icons/weight.png">
      <span>{{ d.array_value.weight }}</span>
      <div class="flex-grow-1 flex justify-content-end">
        <button @click="addDimension()" type="button" class="btn btn-outline-success btn-xs">
          <img src="/assets/icons/new_dimension.png">
          добавить
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['dimensions', 'addDimension']
}

</script>

<style scoped>
img {
  width: 20px;
  height: 20px;
}

</style>
